<template>
  <div class="group-comment-sidebar">
    <b-sidebar
      position="absolute"
      :right="true"
      :fullheight="true"
      :overlay="false"
      :open="isOpen"
      @close="sidebarCancel"
    >
      <div>
        <b-input v-model="searchInput" placeholder="Søg på Navn eller Nummer" class="search-bar"></b-input>

        <div>
          <b-button @click="deSelectAll" class="table-related-button button" v-if="anySelected">
            Fravælg alle
          </b-button>
        </div>
        <div>
          <b-button @click="selectAll" class="table-related-button button" v-if="anyDeSelected">
            Vælg alle
          </b-button>
        </div>
        <div>
          Der er valgt {{ numberOfSelected }}
        </div>
        <b-table v-if="filtered !== undefined" class="sidebar-table table" :data="filtered" hoverable>
          <b-table-column field="number" label="Nummer" v-slot="props">
            {{ props.row.number }}
          </b-table-column>

          <b-table-column field="name" label="Navn" v-slot="props">
            {{ props.row.name }}
          </b-table-column>

          <b-table-column field="isSelected" label="Valgt" v-slot="props">
            <b-field>
              <b-checkbox v-model="props.row.isSelected"></b-checkbox>
            </b-field>
          </b-table-column>
        </b-table>

        <button @click="cancel" class="acceptance-button button is-primary">Anuller</button>
        <button @click="update" class="acceptance-button button is-primary">Vis</button>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import APISTATE from '../../enums/APISTATE';

export default {
  name: "general-statistics-filter-sidebar",
  props: {},
  data: () => ({
    searchInput: "",
    displayedGroupMembers: []
  }),
  mounted() {
    this.displayedGroupMembers = this.groupMembers
  },
  computed: {
    ...mapGetters("generalStatisticsFilteringSidebar", [
      "isOpen",
      "groupMembers",
      "availableGroupMembers"
    ]),
    filtered () {      
      if (!this.searchInput) {
        return this.displayedGroupMembers
      }

      return this.displayedGroupMembers.filter(o => o.name.toLowerCase().includes(this.searchInput.toLowerCase()) || o.number.toString().includes(this.searchInput.toLowerCase()));
    },
    anySelected() {
      if (!this.displayedGroupMembers) {
        return false
      }
      return this.displayedGroupMembers.filter(o => o.isSelected).length > 0
    },
    anyDeSelected() {
      if (!this.displayedGroupMembers) {
        return false
      }
      return this.displayedGroupMembers.filter(o => o.isSelected == false).length > 0
    },
    numberOfSelected () {
      if (!this.displayedGroupMembers) {
        return 0
      }
      return this.displayedGroupMembers.filter(o => o.isSelected).length
    }
  },
  methods: {
    ...mapActions("generalStatisticsFilteringSidebar", [
      "sidebarCancel",
      "updateParentView",
      "setGroupMembers"
    ]),
    update() {
      this.searchInput = "";
      this.setGroupMembers(this.displayedGroupMembers) // Save back
      this.updateParentView()
    },
    cancel() {
      this.searchInput = "";
      this.sidebarCancel();
    },
    deSelectAll(){
      this.displayedGroupMembers.forEach((agm) => {
        if (agm.isSelected || agm.isSelected === undefined) {
          agm.isSelected = false;
        }						
      });
    },
    selectAll(){
      this.displayedGroupMembers.forEach((agm) => {
        if (!agm.isSelected || agm.isSelected === undefined) {
          agm.isSelected = true;
        }						
      });
    }
  },
  watch: {
    'groupMembers'(newValue){
      console.log('watch: salaryTypeGroup....')
      this.displayedGroupMembers = newValue
    }
  }
};
</script>

<style lang="scss">
.search-button{
  margin-bottom:15px;
}
.sidebar-table {
margin:35px 15px 15px 15px;
}
.table-related-button {
  float:right; 
  margin-right:15px;
}
.search-bar {
  margin: 10px 50px 10px 50px;
}
.acceptance-button {
  margin:7px 10px 7px 10px;
}
</style>
